import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { AdiantamentoFolha } from 'src/app/admihair/api/dto/adiantamento-folha';
import { FolhaPessoaFisica } from 'src/app/admihair/api/dto/folha-pessoa-fisica';
import { AdiantamentoFolhaService } from 'src/app/admihair/service/adiantamento-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-adiantamento-detalhar',
  templateUrl: './adiantamento-detalhar.component.html',
  styleUrls: ['./adiantamento-detalhar.component.scss']
})
export class AdiantamentoDetalharComponent implements OnInit {

  permissaoDetalhar: boolean = false;
  loading: boolean = true;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  id?: number;
  adiantamentoFolha?: AdiantamentoFolha;
  parcelasAdiantamentoFolha: FolhaPessoaFisica[] = [];


  constructor(private adiantamentoFolhaService: AdiantamentoFolhaService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService
  ) { }

  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ADIANTAMENTO_FOLHA');
    this.carregarId();
    if (this.permissaoDetalhar) {
      this.carregarAdiantamento();
    }
  }

  carregarAdiantamento() {
    this.adiantamentoFolhaService.buscarPorId(this.id).subscribe({
      next: (data: AdiantamentoFolha) => {
        this.adiantamentoFolha = data;
        if (data.listaFolha)
          this.parcelasAdiantamentoFolha = data.listaFolha;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })

  }

  carregarId() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }


  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
